import React from 'react';
import Logo from './';

export default () => <Logo src="/cj.png" alt="cj" />;
